import { get, writable } from "svelte/store";

export class ConferencePeer {

    constructor(jid=""){

        this.jid = jid;
        this.pl_id = "";   // -- the participant's pl-ws id, read from its "pl_id" presence property
        this.user = null;

        this.tracks = {
            audio: createRemoteTrackState(),
            video: createRemoteTrackState(),
        }
    }

    // -- (re)binds the jitsi participant and pulls its pl_id presence property; returns true when
    // -- the pl_id newly landed so the caller can re-jiggle the tile bindings
    setUser(user){

        this.user = user;

        const pl_id = user?.getProperty?.("pl_id");
        if (!pl_id || this.pl_id === pl_id)
            return false;

        this.pl_id = pl_id;
        return true;
    }

    setRemoteTrack(track){
        const state = this._getTrackState(track);
        if (!state)
            return false;

        state.track.set(track);
        state.muted.set(track?.isMuted?.() === true);
        return true;
    }

    removeRemoteTrack(track){
        const state = this._getTrackState(track);
        if (!state)
            return false;

        if (get(state.track) !== track)
            return false;

        state.track.set(null);
        state.muted.set(false);
        return true;
    }

    setRemoteMute(track){
        const state = this._getTrackState(track);
        if (!state)
            return false;

        const currentTrack = get(state.track);
        if (currentTrack && currentTrack !== track)
            return false;

        state.muted.set(track?.isMuted?.() === true);
        return true;
    }

    subscribeTrack(type, callback){
        return this.tracks[type]?.track?.subscribe(callback);
    }

    subscribeMute(type, callback){
        return this.tracks[type]?.muted?.subscribe(callback);
    }

    _getTrackState(track){
        const type = getTrackType(track);
        return this.tracks[type] ?? null;
    }

}

function createRemoteTrackState(){
    return {
        track: writable(null),
        muted: writable(false),
    };
}

function getTrackType(track){
    return track?.getType?.() ?? track?.type ?? track?.kind ?? null;
}
